<template>
  <div class="content Tabs">

     <b-tabs card>

          <b-tab :title="lang.tab_Properties"  :title-link-class="textColors" :title-item-class="textColors" active >
            <b-container class="bv-example-row">

              {{lang.infotext_1}}: {{selectedTreeItemObject.category}}

              <FormPartPropertiesComponent :lang="lang.PropertyForm"></FormPartPropertiesComponent>
              <br>
              <hr>
              <p>{{lang.infotext_2}}:</p>
              <p><b-badge variant="success">own</b-badge> - {{lang.infotext_3.own}}</p>
              <p><b-badge variant="warning">ancestor</b-badge> - {{lang.infotext_3.ancestor}}</p>
              <p><b-badge variant="danger">descendant</b-badge> - {{lang.infotext_3.descendant}}</p>

            </b-container>
          </b-tab>
          <!-- <b-tab :title="lang.tab_CIS"  :title-link-class="textColors" :title-item-class="textColors">
            <b-container class="bv-example-row">

              <p>{{lang.infotext_4}}: </p>
              <br>
              <b-button @click="getCIS" class="cis-button" size="sm" :variant="variant">{{lang.button_DownloadCIS}}</b-button>



            </b-container>
          </b-tab> -->

        </b-tabs>



  </div>

</template>
<script>
import { mapGetters } from 'vuex'



import FormPartPropertiesComponent from '@/components/shared/FormPartPropertiesComponent'

export default {
  name: "Content",
  components: {
    FormPartPropertiesComponent

  },
  props:{
    lang: Object,

  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      selectedTreeItemObject: 'selectedTreeItemObject'

    }),
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }
  },
  created () {
  



  },

  updated() {
 


  },
  methods:{
    

  },
  watch: {
  //   projectCategoriesData: function(newVal, oldVal) {
  //    this.categoriesData = JSON.parse(newVal.data);


  //  },

  }
}
</script>

<style scooped>



  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }


</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/Properties/Middle/Content/Content.vue